<template>
  <div>
    <el-card class="box-card" v-for="(item, key) in graduationList" :key="key">
      <div class="flex-between">
        <div>姓名：{{item.aac003}}</div>
        <div>身份证号：{{item.aac002}}</div>
      </div>
      <div class="flex-between code-box">
        <div>
          <div>培训卷码：{{item.couponcode}}</div>
          <div>课程名称：{{item.aca112}}</div>
          <div>合格证编号：{{item.hgzbh}}</div>
        </div>
        <div>
          <div>培训卷名称：{{item.couponname}}</div>
          <div>等级：{{item.aca11a}}</div>
          <div>开始学习时间：{{item.ksxxsj}}</div>
        </div>
        <div>
          <div>机构编码：{{item.ahb001}}</div>
          <div>培训意愿登记时间：{{item.aae036}}</div>
          <div>结束学习时间：{{item.jsxxsj}}</div>
        </div>
        <div>
          <div>机构名称：{{item.ahb004}}</div>
          <div>考核结果：{{item.khjg}}</div>
        </div>
      </div>
      <div class="flex-between code-box">
        <div>审核结果：{{item.yae421}}</div>
        <div>审核意见：{{item.yae422}}</div>
        <div>审核人：{{item.yae411}}</div>
        <div>审核机构：{{item.yae413}}</div>
        <div>审核时间：{{item.yae414}}</div>
      </div>

      <div>
        <el-button type="text" @click="certificate(item)">电子结业证主页</el-button>
<!--        <el-button type="text" @click="rchives">电子结业证封皮</el-button>-->
      </div>
    </el-card>

    <el-dialog
      title="提示"
      :visible.sync="imgVisible"
      width="30%">
      <img class="img-box" src="" alt="">
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "graduationInformation",
    data() {
      return{
        graduationList: [],
        imgVisible: false
      }
    },
    mounted() {
      this.graduation()
    },
    methods: {
      //学员结业信息查询
      graduation() {
        this.$http({
          method: 'get',
          // url: '/api/renren-fast/app/zxpxjp/zxpx_13',
          url: '/api/renren-fast/app/examineresult/hgzlist?page=1&limit=10',
        }).then((result) => {
          console.log(result)
          this.graduationList = result.data.page.list
        })
      },
      //电子结业证封皮
      rchives() {
        this.$http({
          method: 'get',
          url: '/api/renren-fast/app/zxpxjp/zxpx_17',
        }).then((result) => {
          console.log(result)
          if (result.data.code == 0) {
            window.open(result.data,result)
          } else {
            this.$message.error('暂未查到结业信息')
          }
        })
      },
      //电子结业证主页
      certificate(val) {
        window.open('http://www.skill18.com:9008/' + val.hgzhome)
        // this.$http({
        //   method: 'get',
        //   url: '/api/renren-fast/app/zxpxjp/zxpx_12',
        //   params: {
        //     aac003: val.aac003,
        //     aac002: val.aac002,
        //     ahb001: val.ahb001,
        //     ahb004: val.ahb004
        //   }
        // }).then((result) => {
        //   console.log(result)
        //   if (result.data.code == 0) {
        //     window.open(result.data,result)
        //   } else {
        //     this.$message.error('暂未查到结业信息')
        //   }
        // })
      }
    }
  }
</script>

<style lang="scss" scoped>
.flex-between{
  display: flex;
  justify-content: space-between;
}
  .flex-box{
    display: flex;
  }
  .code-box{
    margin-top: 10px;
  }
  .img-box{
    width: 100%;
  }
.box-card{
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/graduationInformation.vue